/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RefreshBackendExtensionRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/utility_messages.pb'
import {RefreshBackendExtensionResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/utility_messages.pb'


export const refreshBackendExtension = (request:RefreshBackendExtensionRequest, options?: CashRequestOptions) => post<RefreshBackendExtensionRequest, RefreshBackendExtensionResponse>("/2.0/cash/refresh-backend-extension", request, {...options, rejectOnError: true })